import { gql, useQuery } from '@apollo/client'
import { mapCareerDescription } from '../util-map'
import { CareerDescription } from './type'

const GET_CAREER_DESCRIPTION_BY_SLUG = gql`
  query CareerDescriptionBySlug($slug: String!) {
    pathBySlug(slug: $slug) {
      ... on CareerPath {
        id
        displayGoalTitle
        detailImageKey
        goals {
          title
          description
        }
        objectives {
          imageKey
          title
          description
        }
        target
      }
    }
  }
`

type Response = {
  pathBySlug: CareerDescription
}

const useGetCareerDescription = (slug?: string) => {
  const { data, loading } = useQuery<Response>(GET_CAREER_DESCRIPTION_BY_SLUG, {
    variables: {
      slug,
    },
    skip: slug === undefined,
  })

  return {
    loading,
    careerDescription: mapCareerDescription(data?.pathBySlug),
  }
}

export default useGetCareerDescription
